import { BiAggregation } from "../../../../../../../../../../api/types/fieldConfigurationTypes";

// Frontend-only calculation types for a date column (two custom menu items). Kept off the shared
// CalculationType (which mirrors the backend); a date column is persisted as a normal aggregation,
// so these convert to BiAggregation only when building/reading the field's `aggregation`.
export enum DateCalculationType {
  Earliest = "Earliest",
  Latest = "Latest",
}

export const dateCalculationTypes: DateCalculationType[] = [DateCalculationType.Earliest, DateCalculationType.Latest];

export const dateCalculationCaptions = new Map<DateCalculationType, string>([
  [DateCalculationType.Earliest, "Earliest date"],
  [DateCalculationType.Latest, "Latest date"],
]);

export const getDateCalculationCaption = (type: DateCalculationType): string => dateCalculationCaptions.get(type) ?? "";

export const dateCalculationToAggregation = (type: DateCalculationType): BiAggregation =>
  type === DateCalculationType.Latest ? BiAggregation.Max : BiAggregation.Min;

export const aggregationToDateCalculation = (aggregation: BiAggregation | undefined | null): DateCalculationType =>
  aggregation === BiAggregation.Max ? DateCalculationType.Latest : DateCalculationType.Earliest;

export const buildDateCalculationDefaultName = (
  type: DateCalculationType,
  dateFieldCaption: string | undefined,
  measureCaption: string | undefined
): string => {
  const typeWord = type === DateCalculationType.Latest ? "Latest" : "Earliest";
  const dateShort = (dateFieldCaption ?? "").replace(/\s*date$/i, "").trim();
  return [dateShort, typeWord, measureCaption ?? ""].filter((part) => part.length > 0).join(" ");
};
